import { useEffect, useState } from 'react';
import '../css/MemoryGame.css';
import AFCteamLogos from '../assets/AFCteamLogos';
import NFCteamLogos from '../assets/NFCteamLogos';

const FootballMemory = () => {
    const footballLogos = [
        { name: 'Chicago Bears', logo: NFCteamLogos["Chicago Bears"] },
        { name: 'Green Bay Packers', logo: NFCteamLogos["Green Bay Packers"] },
        { name: 'Detroit Lions', logo: NFCteamLogos["Detroit Lions"] },
        { name: 'Minnesota Vikings', logo: NFCteamLogos["Minnesota Vikings"] },
        { name: 'Dallas Cowboys', logo: NFCteamLogos["Dallas Cowboys"] },
        { name: 'Philadelphia Eagles', logo: NFCteamLogos["Philadelphia Eagles"] },
        { name: 'San Francisco 49ers', logo: NFCteamLogos["San Francisco 49ers"] },
        { name: 'Seattle Seahawks', logo: NFCteamLogos["Seattle Seahawks"] },
        { name: 'Arizona Cardinals', logo: NFCteamLogos["Arizona Cardinals"] },
        { name: 'Los Angeles Rams', logo: NFCteamLogos["Los Angeles Rams"] },
        { name: 'Atlanta Falcons', logo: NFCteamLogos["Atlanta Falcons"] },
        { name: 'New York Giants', logo: NFCteamLogos["New York Giants"] },
        { name: 'Washington Commanders', logo: NFCteamLogos["Washington Commanders"] },
        { name: 'New Orleans Saints', logo: NFCteamLogos["New Orleans Saints"] },
        { name: 'Tampa Bay Buccaneers', logo: NFCteamLogos["Tampa Bay Buccaneers"] },
        { name: 'Carolina Panthers', logo: NFCteamLogos["Carolina Panthers"] },
        { name: 'Kansas City Chiefs', logo: AFCteamLogos["Kansas City Chiefs"] },
        { name: 'Buffalo Bills', logo: AFCteamLogos["Buffalo Bills"] },
        { name: 'Baltimore Ravens', logo: AFCteamLogos["Baltimore Ravens"] },
        { name: 'Cincinnati Bengals', logo: AFCteamLogos["Cincinnati Bengals"] },
        { name: 'Miami Dolphins', logo: AFCteamLogos["Miami Dolphins"] },
        { name: 'New York Jets', logo: AFCteamLogos["New York Jets"] },
        { name: 'Denver Broncos', logo: AFCteamLogos["Denver Broncos"] },
        { name: 'Las Vegas Raiders', logo: AFCteamLogos["Las Vegas Raiders"] },
        { name: 'Los Angeles Chargers', logo: AFCteamLogos["Los Angeles Chargers"] },
        { name: 'New England Patriots', logo: AFCteamLogos["New England Patriots"] },
        { name: 'Jacksonville Jaguars', logo: AFCteamLogos["Jacksonville Jaguars"] },
        { name: 'Houston Texans', logo: AFCteamLogos["Houston Texans"] },
        { name: 'Indianapolis Colts', logo: AFCteamLogos["Indianapolis Colts"] },
        { name: 'Cleveland Browns', logo: AFCteamLogos["Cleveland Browns"] },
        { name: 'Pittsburgh Steelers', logo: AFCteamLogos["Pittsburgh Steelers"] },
        { name: 'Tennessee Titans', logo: AFCteamLogos["Tennessee Titans"] }
    ];

    // make the deck based on the board size
    const buildDeck = (size) => {
        const totalCards = size * size;
        const pairCount = totalCards / 2;
        const pickedLogos = footballLogos.slice(0, pairCount);

        const fullDeck = [...pickedLogos, ...pickedLogos].map((team, index) => ({
            id: `${team.name}-${index}`,
            name: team.name,
            logo: team.logo
        }));

        const shuffledDeck = [...fullDeck];

        for (let i = shuffledDeck.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            const temp = shuffledDeck[i];
            shuffledDeck[i] = shuffledDeck[randomIndex];
            shuffledDeck[randomIndex] = temp;
        }

        return shuffledDeck;
    };

    const [boardSize, setBoardSize] = useState(4);
    const [cards, setCards] = useState(buildDeck(4));
    const [flippedCards, setFlippedCards] = useState([]);
    const [matchedCards, setMatchedCards] = useState([]);
    const [moves, setMoves] = useState(0);
    const [gameWon, setGameWon] = useState(false);
    const [isChecking, setIsChecking] = useState(false);

    // start or restart the game
    const startGame = (size = boardSize) => {
        setCards(buildDeck(size));
        setFlippedCards([]);
        setMatchedCards([]);
        setMoves(0);
        setGameWon(false);
        setIsChecking(false);
    };

    useEffect(() => {
        if (cards.length > 0 && matchedCards.length === cards.length) {
            setGameWon(true);
        }
    }, [matchedCards, cards]);

    // flip the card when user clicks it
    const handleCardClick = (card) => {
        if (isChecking) return;
        if (matchedCards.includes(card.id)) return;
        if (flippedCards.find((item) => item.id === card.id)) return;
        if (flippedCards.length === 2) return;

        const newFlippedCards = [...flippedCards, card];
        setFlippedCards(newFlippedCards);

        // once 2 cards are flipped, check if they match
        if (newFlippedCards.length === 2) {
            setMoves((prev) => prev + 1);
            setIsChecking(true);

            if (newFlippedCards[0].name === newFlippedCards[1].name) {
                setTimeout(() => {
                    setMatchedCards((prev) => [
                        ...prev,
                        newFlippedCards[0].id,
                        newFlippedCards[1].id
                    ]);
                    setFlippedCards([]);
                    setIsChecking(false);
                }, 500);
            } else {
                setTimeout(() => {
                    setFlippedCards([]);
                    setIsChecking(false);
                }, 850);
            }
        }
    };

    const cardIsFlipped = (card) => {
        return matchedCards.includes(card.id) || flippedCards.find((item) => item.id === card.id);
    };

    return (
        <main className="memory-page">
            <section className="memory-top-box">
                <h1> Memory Game: Football </h1>
                <p>Match all of the football logos to its match.</p>

                <div className="memory-controls">
                    <label htmlFor="football-board-size">Board Size:</label>
                    <select
                        id="football-board-size"
                        className="memory-select"
                        value={boardSize}
                        onChange={(e) => {
                            const newSize = Number(e.target.value);
                            setBoardSize(newSize);
                            startGame(newSize);
                        }}
                    >
                        <option value={4}>4 x 4</option>
                        <option value={6}>6 x 6</option>
                        <option value={8}>8 x 8</option>
                    </select>

                    <button
                        type="button"
                        className="memory-btn"
                        onClick={() => startGame(boardSize)}
                    >
                        Play Again
                    </button>
                </div>

                <div className="memory-stats">
                    <span>Moves: {moves}</span>
                    <span>Matches: {matchedCards.length / 2}</span>
                </div>

                {gameWon && (
                    <p className="memory-win">
                        You matched them all in {moves} moves!
                    </p>
                )}
            </section>

            <section className="memory-board-box">
                <div className={`memory-grid grid-${boardSize}`}>
                    {cards.map((card) => (
                        <button
                            key={card.id}
                            type="button"
                            className={`memory-card size-${boardSize} ${cardIsFlipped(card) ? 'flipped' : ''} ${matchedCards.includes(card.id) ? 'matched' : ''}`}
                            onClick={() => handleCardClick(card)}
                        >
                            <div className="memory-card-inner">
                                <div className="memory-card-front"></div>
                                <div className="memory-card-back">
                                    <img src={card.logo} alt={card.name} />
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            </section>
        </main>
    );
};

export default FootballMemory;